module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('input', {
    ref: "digit.id",
    staticClass: "input-digit",
    class: ( _obj = {
      recognizable: _vm.recognizable, loading: _vm.seending, wrong_preenchimento: _vm.wrongPreenchimento, blur: _vm.isToBlurDigit
    }, _obj[("InputDigit-" + (_vm.position[0]) + "-" + (_vm.position[1]))] = true, _obj ),
    attrs: {
      "type": "text",
      "disabled": _vm.seendingSheet || !_vm.canEditCurrentSheet
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "click": function($event) {
        _vm.clickDigit($event)
      },
      "keydown": function($event) {
        $event.preventDefault();
        _vm.changeCurrentPosition($event)
      },
      "keyup": function($event) {
        $event.preventDefault();
        _vm.changeCurrentDigit($event)
      }
    }
  })])
  var _obj;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44ac0ed8"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=jade!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sheet/InputDigit.vue
// module id = 340
// module chunks = 2